import { render, staticRenderFns } from "./TableViewManager.vue?vue&type=template&id=2986447e&scoped=true&"
import script from "./TableViewManager.vue?vue&type=script&lang=js&"
export * from "./TableViewManager.vue?vue&type=script&lang=js&"
import style0 from "./TableViewManager.vue?vue&type=style&index=0&id=2986447e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986447e",
  null
  
)

export default component.exports